import { AnimatedMapBackground } from "./animated-map-background";

// The animated map behind the app's sign-in / sign-up pages (Lovable "login" / "signup").
// Place it as the first child of an element carrying `data-map-section` (it sizes the map and the pins
// steer clear of that element's `data-map-protected` children). The wrapper carries `mk-root` so the
// map's Tailwind utilities resolve outside the marketing layout.
export function AuthMapBackground() {
	return (
		<div className="mk-root mk-embed" aria-hidden="true">
			<AnimatedMapBackground />
		</div>
	);
}
